/*
 * @Description: 常用图表
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2020-10-14 16:23:21
 */
import React from 'react';
import CustomLayout from '../../components/CustomLayout';
import getComponent, {router} from './getComponent';
import Link from '../../components/Link/Link';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './custom.css'

// const routerMap = {
//   IndustryContent: '品牌内容/行业内容占比',
//   WordOfMouthContrast: '用户口碑正负向对比图',
//   ShareOfMind: '心智占有率图',
//   KOL: 'KOL参与图',
//   Favor: '受众好感图',
//   ChartPie: '分平台口碑舆情图',
//   ChartPieRatio: '内容分平台占比',
//   venn: '内容交集图',
//   KeyValuePie: '认知关键词'
// }

const routerMap = {
  IndustryContent: {
    name: '条形图/柱形图',
    type: 'bar'
  },
  FiveFavor: {
    name: '五级情感倾向',
    type: 'bar'
  },
  WordOfMouthContrast: {
    name: '用户口碑正负向对比图',
    type: 'bar'
  },
  ShareOfMind: {
    name: '心智占有率图',
    type: 'pie'
  },
  KOL: {
    name: 'KOL参与图',
    type: 'pie'
  },
  Favor: {
    name: '受众好感图',
    type: 'pie'
  },
  ChartPie: {
    name: '传统饼图',
    type: 'pie'
  },
  ChartPieRatio: {
    name: '内容分平台占比',
    type: 'pie'
  },
  venn: {
    name: '内容交集图',
    type: 'pie'
  },
  KeyValuePie: {
    name: '认知关键词',
    type: 'pie'
  },
  Multiaxis: {
    name: '多坐标轴',
    type: 'bar'
  },
  MultiaxisD3: {
    name: '多坐标轴D3',
    type: 'bar'
  },
  WordCloud: {
    name: '词云图',
    type: 'wordCloud'
  },
  KeyMediaGraph: {
    name: '关键媒体关系图',
    type: 'graph'
  },
  HotTopic: {
    name: '最热topic',
    type: 'graph'
  }
}


class Layout extends React.Component {
  renderRouterGroup () {
    const links = Object.keys(router)

    let routerGroup = {
      pie: [],
      bar: [],
      wordCloud: [],
      graph: []
    } 

    links.forEach(item => {
      const ele = routerMap[item]
      routerGroup[ele.type].push({
        name: ele.name,
        url: item
      })
    })

    return (
      <section className={s.ul}>
        <div>
          <h3 className={s.ulTitle}>饼图</h3>
          <div> 
            {routerGroup.pie.map(item => {
              if (typeof item === 'string') {
                return <Link className={s.li} to={`/customChart/${item}`} key={item}>{item}</Link>
              }
              return <Link className={s.li} to={`/customChart/${item.url}`} key={item.url}>{item.name}</Link>
            })}
          </div>
        </div>
        <div>
          <h3  className={s.ulTitle}>条形图</h3>
          <div> 
            {routerGroup.bar.map(item => {
              if (typeof item === 'string') {
                return <Link  className={s.li} to={`/customChart/${item}`} key={item}>{item}</Link>
              }
              return <Link  className={s.li} to={`/customChart/${item.url}`} key={item.url}>{item.name}</Link>
            })}
          </div>
        </div>
        <div>
          <h3  className={s.ulTitle}>词云图</h3>
          <div> 
            {routerGroup.wordCloud.map(item => {
              if (typeof item === 'string') {
                return <Link  className={s.li} to={`/customChart/${item}`} key={item}>{item}</Link>
              }
              return <Link  className={s.li} to={`/customChart/${item.url}`} key={item.url}>{item.name}</Link>
            })}
          </div>
        </div>
        <div>
          <h3  className={s.ulTitle}>关系图</h3>
          <div> 
            {routerGroup.graph.map(item => {
              if (typeof item === 'string') {
                return <Link  className={s.li} to={`/customChart/${item}`} key={item}>{item}</Link>
              }
              return <Link  className={s.li} to={`/customChart/${item.url}`} key={item.url}>{item.name}</Link>
            })}
          </div>
        </div>
      </section>
    )
  }

  render () {
    return (
      <CustomLayout  header={this.renderRouterGroup}>
        {this.props.children}
      </CustomLayout>
    )
  }
}

const LayoutWithStyle = withStyles(s)(Layout)

const title = '常用图表';

export default {

  path: '/customChart',
  // @ts-ignore
  async action(...res) {
    return //console.log(res)
  },
  children: [
    {
      path: '/',
      action () {
        const com = getComponent('IndustryContent');
        return {
          title,
          component: com
        }
      }
    },
    {
      path: '/SetPage',
      action () {
        const SetPage = getComponent('SetPage');
        return {
          title,
          component: <LayoutWithStyle>
            <SetPage></SetPage>  
          </LayoutWithStyle>
        }
      }
    },
    {
      path: '/:page',
      action (context) {
        const current = context.params.page;
        const Page = getComponent(current)

        return {
          title: `${current} - ${title}`,
          chunk: 'customChart',
          component: <LayoutWithStyle>
            <Page></Page>
          </LayoutWithStyle>
        }
      }
    }
  ]

};



// WEBPACK FOOTER //
// src/routes/customChart/index.js